import { TShiftsActions, ShiftsActionTypes } from './shifts.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { TRESPONSE_SHIFTS, SessionTimes } from '@monorepo/types';

// 01 Create Enity Interface for Shifts
export interface IShiftsState extends EntityState<TRESPONSE_SHIFTS[0]> {
  selectShiftId: string | null;
  isWithinWorkingHours: boolean | null;
  sessionTimes: SessionTimes | null;
}

// 02 Create entity adapter
const adapter: EntityAdapter<TRESPONSE_SHIFTS[0]> = createEntityAdapter<TRESPONSE_SHIFTS[0]>({
  selectId: (shift) => shift.id,
});

// 03 Initial State of reducer
export const initialState = adapter.getInitialState({
  selectShiftId: null,
  isWithinWorkingHours: null,
  sessionTimes: null,
});

export function shiftsReducer(state = initialState, action: TShiftsActions): IShiftsState {
  switch (action.type) {
    case ShiftsActionTypes.SelectShift:
      return Object.assign({}, state, { selectShiftId: action.payload });
    case ShiftsActionTypes.ShiftsLoaded:
      return adapter.addMany(action.payload, state);
    case ShiftsActionTypes.ChangeShiftId:
      return {
        ...state,
        selectShiftId: action.shiftId,
      };
    case ShiftsActionTypes.UpdateSessionHoursStatus:
      return {
        ...state,
        isWithinWorkingHours: action.isWithinWorkingHours,
        sessionTimes: action.sessionTimes || state.sessionTimes,
      };
    default:
      return state;
  }
}

export const getSelectedShiftId = (shiftsState: IShiftsState) => shiftsState.selectShiftId;

const { selectEntities } = adapter.getSelectors();

export const selectAllShifts = selectEntities;
